var render = function render(){var _vm=this,_c=_vm._self._c;return _c('role-list',{attrs:{"hidden-actions":['create'],"id":_vm.id,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }